<p>type-intervention-details works!</p>
